import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { RouteFallback } from '@/components/layout/RouteFallback';
import { OverlayLayer } from '@/components/ui/overlayLayer';
import { usePaneId } from '@/components/workspace/PaneContext';
import { SidebarProvider } from '@/contexts/SidebarContext';
import { TopNav } from './TopNav';

export function MainLayout() {
  const paneId = usePaneId();

  // Inside a workspace pane: no global nav (the pane has its own chrome), its
  // own scroll box, and its own SidebarProvider so two panes of the same app
  // cannot fight over one registration. `@container/pane` is what lets pages
  // adopt container queries later — see docs/MULTI_APP_WORKSPACE.md §4.7.
  // Deliberately not a <main>: the page already has one.
  if (paneId) {
    return (
      <SidebarProvider>
        {/* The pane's overlay layer sits beside the scroll box, so panels,
            dialogs and popovers open inside the pane (components/ui/overlayLayer). */}
        <OverlayLayer className="@container/pane h-full min-h-0">
          <div data-pane-scroll className="h-full min-h-0 overflow-y-auto">
            <Suspense fallback={<RouteFallback />}>
              <Outlet />
            </Suspense>
          </div>
        </OverlayLayer>
      </SidebarProvider>
    );
  }

  return (
    <SidebarProvider>
      <div className="text-foreground flex min-h-screen flex-col bg-background">
        <TopNav />
        <main className="min-h-0 flex-1">
          <Suspense fallback={<RouteFallback />}>
            <Outlet />
          </Suspense>
        </main>
      </div>
    </SidebarProvider>
  );
}
